import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	profileMenu: {
		display: "flex",
		width: "100%",
		alignItems: "center",
		justifyContent: "flex-start",
		paddingLeft: theme.spacing(1.25),
		paddingRight: theme.spacing(2),
		paddingTop: theme.spacing(1.25),
		paddingBottom: theme.spacing(1.5),
		minHeight: theme.spacing(6),
		gap: theme.spacing(1.25),
		cursor: "pointer",
		"&:hover": { backgroundColor: colors.gray[100] }
	},
	profileMenuSecondary: {
		"&:hover": { backgroundColor: colors.purple[400] }
	},
	profileMenuCollapsed: {
		justifyContent: "center",
		padding: theme.spacing(1),
		width: "fit-content",
		margin: `${theme.spacing(0.75)} auto`
	},
	nameTextSecondary: {
		color: colors.gray[0]
	},
	emailTextSecondary: {
		color: colors.gray[0]
	},
	avatar: {
		width: 36,
		height: 36,
		border: `1px solid ${colors.purple[100]}`,
		backgroundColor: colors.gray[0],
		color: colors.purple[600]
	},
	avatarSecondary: {
		border: "none",
		backgroundColor: colors.purple[700],
		color: colors.gray[0]
	},
	usernameWrapper: {
		flex: 1,
		minWidth: 0,
		overflow: "hidden"
	},
	nameText: {
		color: colors.gray[800],
		fontWeight: 500,
		lineHeight: 1.3,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	emailText: {
		color: colors.gray[500],
		lineHeight: 1.2,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	chevron: {
		flexShrink: 0,
		color: colors.purple[100]
	},
	chevronSecondary: {
		color: colors.gray[0]
	}
}))

export default useStyles
